namespace AgerLMS {
    export enum OrderStates {
        OrderPlaced = 0,
        OrderConfirmed = 1,
        OrderShipped = 2,
        OrderDelivered = 3,
        OrderCompleted = 4,
        OrderCanceled = 5,
        PaymentPending = 6
    }
    Serenity.Decorators.registerEnumType(OrderStates, 'AgerLMS.OrderStates');
}
